import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ArrowDateTime: any;
  /** Cursor for paging through collections */
  ConnectionCursor: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** A signed decimal number, which supports arbitrary precision and is serialized as a string. Example value: `"29.99"` */
  Decimal: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  TypePreservingID: any;
};

export type AddAuthorizedSubmitterInput = {
  purchaseAccountId: Scalars['String'];
  userId: Scalars['String'];
};

export type AddAuthorizedSubmitterResult = MutationResult & {
  __typename?: 'AddAuthorizedSubmitterResult';
  authorizedSubmitter?: Maybe<AuthorizedSubmitterV2>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AdjustedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'AdjustedPurchaseOrderEventLog';
  adjustedLineItems: Array<PurchaseOrderLineItem>;
  changes: AdjustmentJsonStructure;
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
  receiver: PurchaseOrderReceiver;
};

export type AdjustedPurchaseOrderEventLogConnection = {
  __typename?: 'AdjustedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<AdjustedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AdjustedPurchaseOrderEventLogEdge = {
  __typename?: 'AdjustedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the AdjustedPurchaseOrderEventLog */
  node: AdjustedPurchaseOrderEventLog;
};

export type AdjustedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<AdjustedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AdjustedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type AdjustedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: AdjustedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AdjustedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type AdjustmentJsonStructure = {
  __typename?: 'AdjustmentJSONStructure';
  adjustments: Array<LineItemAdjustmentFields>;
  receiver_id: Scalars['String'];
};

export type AllocationSnapshot = {
  __typename?: 'AllocationSnapshot';
  allocationId?: Maybe<Scalars['ID']>;
  allocationName?: Maybe<Scalars['String']>;
  allocationType: PurchaseOrderLineItemAllocation;
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type ApprovedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'ApprovedPurchaseOrderEventLog';
  amountApproved: Money;
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
};

export type ApprovedPurchaseOrderEventLogConnection = {
  __typename?: 'ApprovedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<ApprovedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ApprovedPurchaseOrderEventLogEdge = {
  __typename?: 'ApprovedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the ApprovedPurchaseOrderEventLog */
  node: ApprovedPurchaseOrderEventLog;
};

export type ApprovedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<ApprovedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ApprovedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type ApprovedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: ApprovedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ApprovedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type ApprovePurchaseOrderInput = {
  purchaseOrderId: Scalars['ID'];
};

export type ApprovePurchaseOrderResult = MutationResult & {
  __typename?: 'ApprovePurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type ArchivePurchaseOrderInput = {
  periodStart?: InputMaybe<Scalars['DateTime']>;
  purchaseOrderId: Scalars['ID'];
};

export type ArchivePurchaseOrderResult = MutationResult & {
  __typename?: 'ArchivePurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type AssignItemsToPurchaseInputItem = {
  allocationId?: InputMaybe<Scalars['ID']>;
  allocationType?: Scalars['String'];
  description?: Scalars['String'];
  itemId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  pricePerUnit: MoneyInput;
  quantity: Scalars['Int'];
};

export type AssignItemsToUnopenedPurchaseOrderInput = {
  lineItems: Array<AssignItemsToUnopenedPurchaseOrderInputItem>;
  purchaseOrderId: Scalars['ID'];
};

export type AssignItemsToUnopenedPurchaseOrderInputItem = {
  allocationId?: InputMaybe<Scalars['ID']>;
  allocationType?: InputMaybe<PurchaseOrderLineItemAllocation>;
  description?: Scalars['String'];
  itemId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  pricePerUnit: MoneyInput;
  quantity: Scalars['Int'];
};

export type AssignItemsToUnopenedPurchaseOrderResult = MutationResult & {
  __typename?: 'AssignItemsToUnopenedPurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type AssignItemToExternalPurchaseOrderInput = {
  allocationId?: InputMaybe<Scalars['ID']>;
  allocationType?: InputMaybe<PurchaseOrderLineItemAllocation>;
  description?: Scalars['String'];
  itemId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  pricePerUnit: MoneyInput;
  quantity: Scalars['Int'];
};

export type AssignItemToPurchaseInput = {
  description?: Scalars['String'];
  itemId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  pricePerUnit: MoneyInput;
  quantity: Scalars['Int'];
};

export type AssignItemToPurchaseOrderInput = {
  allocationId?: InputMaybe<Scalars['ID']>;
  allocationType?: InputMaybe<PurchaseOrderLineItemAllocation>;
  description?: Scalars['String'];
  itemId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  pricePerUnit: MoneyInput;
  quantity: Scalars['Int'];
};

export type AssignReceiptItemToPurchaseReceiptInput = {
  acceptedQuantity: Scalars['Float'];
  purchaseLineItemId: Scalars['ID'];
  rejectedQuantity?: InputMaybe<Scalars['Float']>;
};

export type AssignReceiverItemToPurchaseOrderReceiverInput = {
  acceptedQuantity?: InputMaybe<Scalars['Float']>;
  newPrice?: InputMaybe<MoneyInput>;
  purchaseOrderLineItemId: Scalars['ID'];
  rejectedQuantity?: InputMaybe<Scalars['Float']>;
};

export type AuthorizedSubmitter = {
  __typename?: 'AuthorizedSubmitter';
  authorizedUser: ProcurementsUser;
  authorizedUserId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  modifiedAt: Scalars['DateTime'];
  purchaseUser: ProcurementsUser;
  purchaseUserId: Scalars['Int'];
};

export type AuthorizedSubmitterConnection = {
  __typename?: 'AuthorizedSubmitterConnection';
  /** Array of edges. */
  edges: Array<AuthorizedSubmitterEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AuthorizedSubmitterEdge = {
  __typename?: 'AuthorizedSubmitterEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the AuthorizedSubmitter */
  node: AuthorizedSubmitter;
};

export type AuthorizedSubmitterFilter = {
  and?: InputMaybe<Array<AuthorizedSubmitterFilter>>;
  authorizedUserId?: InputMaybe<IntFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IntFieldComparison>;
  modifiedAt?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<AuthorizedSubmitterFilter>>;
  purchaseUserId?: InputMaybe<IntFieldComparison>;
};

export type AuthorizedSubmitterSort = {
  direction: SortDirection;
  field: AuthorizedSubmitterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AuthorizedSubmitterSortFields {
  AuthorizedUserId = 'authorizedUserId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  PurchaseUserId = 'purchaseUserId'
}

export type AuthorizedSubmitterV2 = Node & {
  __typename?: 'AuthorizedSubmitterV2';
  dateAdded: Scalars['DateTime'];
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
  purchaseAccountId: Scalars['ID'];
  user: ProcurementsUser;
  userId: Scalars['ID'];
};

export type BetaTestUserAuthorizationResult = {
  __typename?: 'BetaTestUserAuthorizationResult';
  hasAccess: Scalars['Boolean'];
  userId?: Maybe<Scalars['ID']>;
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
};

export type Branch = Node & {
  __typename?: 'Branch';
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  isCostCaptureLocation: Scalars['Boolean'];
  name: Scalars['String'];
};

export type BranchConnection = {
  __typename?: 'BranchConnection';
  edges: Array<BranchEdge>;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type BranchEdge = {
  __typename?: 'BranchEdge';
  node: Branch;
};

export type BranchOffsetPagingInput = {
  /** How many items to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** The index of the item to start after. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type BranchSnapshot = {
  __typename?: 'BranchSnapshot';
  branchId: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
  locationCity: Scalars['String'];
  locationStateAbbreviation: Scalars['String'];
  locationStateName: Scalars['String'];
  locationStreet1: Scalars['String'];
  locationStreet2: Scalars['String'];
  locationZipCode: Scalars['String'];
  name: Scalars['String'];
};

export type BusinessDepartmentSnapshot = BusinessUnitSnapshot & {
  __typename?: 'BusinessDepartmentSnapshot';
  createdAt: Scalars['DateTime'];
  departmentId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BusinessExpenseLineSnapshot = BusinessUnitSnapshot & {
  __typename?: 'BusinessExpenseLineSnapshot';
  createdAt: Scalars['DateTime'];
  expenseLineId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BusinessSubDepartmentSnapshot = BusinessUnitSnapshot & {
  __typename?: 'BusinessSubDepartmentSnapshot';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  subDepartmentId: Scalars['ID'];
};

export type BusinessUnitSnapshot = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ChangeState = {
  __typename?: 'ChangeState';
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
};

export type ClosedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'ClosedPurchaseOrderEventLog';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
};

export type ClosedPurchaseOrderEventLogConnection = {
  __typename?: 'ClosedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<ClosedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ClosedPurchaseOrderEventLogEdge = {
  __typename?: 'ClosedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the ClosedPurchaseOrderEventLog */
  node: ClosedPurchaseOrderEventLog;
};

export type ClosedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<ClosedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ClosedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type ClosedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: ClosedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ClosedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type ClosePurchaseOrderInput = {
  purchaseOrderId: Scalars['ID'];
};

export type ClosePurchaseOrderResult = MutationResult & {
  __typename?: 'ClosePurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type CostCenterSnapshot = {
  __typename?: 'CostCenterSnapshot';
  branchId: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
  location: CostCenterSnapshotLocation;
  locationCity: Scalars['String'];
  locationStateAbbreviation: Scalars['String'];
  locationStateName: Scalars['String'];
  locationStreet1: Scalars['String'];
  locationStreet2: Scalars['String'];
  locationZipCode: Scalars['String'];
  name: Scalars['String'];
};

export type CostCenterSnapshotLocation = {
  __typename?: 'CostCenterSnapshotLocation';
  city: Scalars['String'];
  stateAbbreviation: Scalars['String'];
  stateName: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type CreateAuthorizedSubmitterInput = {
  authorizedUserEmail?: InputMaybe<Scalars['String']>;
  authorizedUserId?: InputMaybe<Scalars['Int']>;
};

export type CreateAuthorizedSubmitterResult = MutationResult & {
  __typename?: 'CreateAuthorizedSubmitterResult';
  authorizedSubmitter?: Maybe<AuthorizedSubmitter>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateBulkReceiversAdjustmentInput = {
  dateReceived: Scalars['DateTime'];
  note?: InputMaybe<Scalars['String']>;
  periodStart?: InputMaybe<Scalars['DateTime']>;
  purchaseOrderId: Scalars['ID'];
  receiverItems: Array<CreateBulkReceiversAdjustmentItemInput>;
};

export type CreateBulkReceiversAdjustmentItemInput = {
  acceptedQuantity?: InputMaybe<Scalars['Float']>;
  newPrice?: InputMaybe<MoneyInput>;
  purchaseOrderLineItemId: Scalars['ID'];
  rejectedQuantity?: InputMaybe<Scalars['Float']>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type CreateBulkReceiversAdjustmentResult = MutationResult & {
  __typename?: 'CreateBulkReceiversAdjustmentResult';
  message: Scalars['String'];
  purchaseOrderReceivers?: Maybe<Array<PurchaseOrderReceiver>>;
  success: Scalars['Boolean'];
};

export type CreatedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'CreatedPurchaseOrderEventLog';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
};

export type CreatedPurchaseOrderEventLogConnection = {
  __typename?: 'CreatedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<CreatedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type CreatedPurchaseOrderEventLogEdge = {
  __typename?: 'CreatedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the CreatedPurchaseOrderEventLog */
  node: CreatedPurchaseOrderEventLog;
};

export type CreatedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<CreatedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CreatedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type CreatedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: CreatedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CreatedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type CreateExternalPurchaseOrderInput = {
  deliverToId: Scalars['ID'];
  lineItems: Array<AssignItemToExternalPurchaseOrderInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  purchaseOrderNumber: Scalars['String'];
  reference: Scalars['String'];
  requestingBranchId: Scalars['ID'];
  status?: PurchaseOrderStatus;
  storeId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

export type CreateExternalPurchaseOrderResult = MutationResult & {
  __typename?: 'CreateExternalPurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type CreateNonInventoryItemInput = {
  allocationType?: InputMaybe<NonInventoryItemAllocation>;
  buyable?: InputMaybe<Scalars['Boolean']>;
  isAllocationRequired?: Scalars['Boolean'];
  name: Scalars['String'];
  preferredVendorId?: InputMaybe<Scalars['String']>;
  sellable?: InputMaybe<Scalars['Boolean']>;
};

export type CreateNonInventoryItemResult = MutationResult & {
  __typename?: 'CreateNonInventoryItemResult';
  item?: Maybe<NonInventoryItem>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreatePriceListInput = {
  name: Scalars['String'];
};

export type CreatePriceListResult = MutationResult & {
  __typename?: 'CreatePriceListResult';
  message: Scalars['String'];
  priceList?: Maybe<PriceList>;
  success: Scalars['Boolean'];
};

export type CreatePurchaseInput = {
  accountType: PurchaseAccountType;
  departmentId?: InputMaybe<Scalars['ID']>;
  expenseLineId?: InputMaybe<Scalars['ID']>;
  grandTotal: MoneyInput;
  imageUrls?: Array<Scalars['String']>;
  /** V2 Field: For new expenses app. */
  isDisputed?: Scalars['Boolean'];
  /** V2 Field: For new expenses app. */
  isPersonalExpense?: Scalars['Boolean'];
  /** V2 Field: For new expenses app. */
  isReturn?: Scalars['Boolean'];
  lineItems?: InputMaybe<Array<AssignItemToPurchaseInput>>;
  marketId: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  /** V2 Field: For new Expenses app. */
  purchaseAccountId?: InputMaybe<Scalars['ID']>;
  purchasedAt: Scalars['DateTime'];
  purchaseUserId: Scalars['Int'];
  subDepartmentId?: InputMaybe<Scalars['ID']>;
  unofficialVendorName?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};

export type CreatePurchaseOrderInput = {
  deliverToId: Scalars['ID'];
  lineItems: Array<AssignItemToPurchaseOrderInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  reference: Scalars['String'];
  requestingBranchId: Scalars['ID'];
  status?: PurchaseOrderStatus;
  storeId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

export type CreatePurchaseOrderReceiverInput = {
  dateReceived?: InputMaybe<Scalars['DateTime']>;
  note?: InputMaybe<Scalars['String']>;
  purchaseOrderId: Scalars['ID'];
  receiverItems?: InputMaybe<Array<AssignReceiverItemToPurchaseOrderReceiverInput>>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type CreatePurchaseOrderReceiverResult = MutationResult & {
  __typename?: 'CreatePurchaseOrderReceiverResult';
  message: Scalars['String'];
  purchaseOrderReceiver?: Maybe<PurchaseOrderReceiver>;
  success: Scalars['Boolean'];
};

export type CreatePurchaseOrderResult = MutationResult & {
  __typename?: 'CreatePurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type CreatePurchaseReceiptInput = {
  note?: InputMaybe<Scalars['String']>;
  purchaseId: Scalars['ID'];
  receiptItems?: InputMaybe<Array<AssignReceiptItemToPurchaseReceiptInput>>;
  storeId?: InputMaybe<Scalars['ID']>;
};

export type CreatePurchaseReceiptResult = MutationResult & {
  __typename?: 'CreatePurchaseReceiptResult';
  message: Scalars['String'];
  purchaseReceipt?: Maybe<PurchaseReceipt>;
  success: Scalars['Boolean'];
};

export type CreatePurchaseResult = MutationResult & {
  __typename?: 'CreatePurchaseResult';
  message: Scalars['String'];
  purchase?: Maybe<Purchase>;
  success: Scalars['Boolean'];
};

export type CreateServiceItemInput = {
  buyable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  preferredVendorId?: InputMaybe<Scalars['String']>;
  sellable?: InputMaybe<Scalars['Boolean']>;
};

export type CreateServiceItemResult = MutationResult & {
  __typename?: 'CreateServiceItemResult';
  item?: Maybe<ServiceItem>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum CurrencyCode {
  Usd = 'USD'
}

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']>;
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime'];
  upper: Scalars['DateTime'];
};

export type DeleteAllPurchaseLineItemsInput = {
  purchaseId: Scalars['Int'];
};

export type DeleteAllPurchaseLineItemsResult = MutationResult & {
  __typename?: 'DeleteAllPurchaseLineItemsResult';
  message: Scalars['String'];
  purchase?: Maybe<Purchase>;
  success: Scalars['Boolean'];
};

export type DeleteAuthorizedSubmitterInput = {
  id: Scalars['Int'];
};

export type DeleteAuthorizedSubmitterResult = MutationResult & {
  __typename?: 'DeleteAuthorizedSubmitterResult';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeletedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'DeletedPurchaseOrderEventLog';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
};

export type DeletedPurchaseOrderEventLogConnection = {
  __typename?: 'DeletedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<DeletedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DeletedPurchaseOrderEventLogEdge = {
  __typename?: 'DeletedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the DeletedPurchaseOrderEventLog */
  node: DeletedPurchaseOrderEventLog;
};

export type DeletedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<DeletedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DeletedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type DeletedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: DeletedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DeletedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type DeletePurchaseLineItemInput = {
  purchaseLineItemId: Scalars['ID'];
};

export type DeletePurchaseOrderLineItemInput = {
  purchaseOrderLineItemId: Scalars['ID'];
};

export type DeliverToSnapshot = {
  __typename?: 'DeliverToSnapshot';
  branchId: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
  location: DeliverToSnapshotLocation;
  locationCity: Scalars['String'];
  locationStateAbbreviation: Scalars['String'];
  locationStateName: Scalars['String'];
  locationStreet1: Scalars['String'];
  locationStreet2: Scalars['String'];
  locationZipCode: Scalars['String'];
  name: Scalars['String'];
};

export type DeliverToSnapshotLocation = {
  __typename?: 'DeliverToSnapshotLocation';
  city: Scalars['String'];
  stateAbbreviation: Scalars['String'];
  stateName: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type EditedFieldResolverUnion = BranchSnapshot | StringBoxValue | VendorSnapshot;

export type EditedLineItem = {
  __typename?: 'EditedLineItem';
  changes: PoLineItemFieldChanges;
  id: Scalars['String'];
};

export type EditedLineItemFieldResolverUnion = AllocationSnapshot | InventoryItemSnapshot | Money | NonInventoryItemSnapshot | ServiceItemSnapshot | StringBoxValue;

export type EditedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'EditedPurchaseOrderEventLog';
  addedLineItems: Array<PurchaseOrderLineItem>;
  changed: Array<PoFieldTypes>;
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  editedLineItems: Array<EditedPurchaseOrderLineItem>;
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
  removedLineItems: Array<PurchaseOrderLineItem>;
};

export type EditedPurchaseOrderEventLogConnection = {
  __typename?: 'EditedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<EditedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type EditedPurchaseOrderEventLogEdge = {
  __typename?: 'EditedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the EditedPurchaseOrderEventLog */
  node: EditedPurchaseOrderEventLog;
};

export type EditedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<EditedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<EditedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type EditedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: EditedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum EditedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type EditedPurchaseOrderLineItem = {
  __typename?: 'EditedPurchaseOrderLineItem';
  changed: Array<PoLineItemFieldTypes>;
  changes: PoLineItemFieldChanges;
  id: Scalars['String'];
  lineItem: PurchaseOrderLineItem;
};

export type EnrollPurchaseAccountInput = {
  purchaseAccountId: Scalars['ID'];
};

export type EnrollPurchaseAccountResult = MutationResult & {
  __typename?: 'EnrollPurchaseAccountResult';
  message: Scalars['String'];
  purchaseAccount?: Maybe<PurchaseAccount>;
  success: Scalars['Boolean'];
};

export type EsBranch = {
  __typename?: 'EsBranch';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FullyReceivePurchaseInput = {
  purchaseId: Scalars['Int'];
  storeId: Scalars['ID'];
};

export type FullyReceivePurchaseResult = MutationResult & {
  __typename?: 'FullyReceivePurchaseResult';
  closed: Scalars['Boolean'];
  message: Scalars['String'];
  purchase?: Maybe<Purchase>;
  success: Scalars['Boolean'];
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  iLike?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  neq?: InputMaybe<Scalars['ID']>;
  notILike?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
  notLike?: InputMaybe<Scalars['ID']>;
};

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int'];
  upper: Scalars['Int'];
};

export type InventoryItem = Item & Node & {
  __typename?: 'InventoryItem';
  buyable: Scalars['Boolean'];
  companyId: Scalars['ID'];
  createdById: Scalars['ID'];
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  duplicateOfId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemType: ItemType;
  manufacturer?: Maybe<Manufacturer>;
  manufacturerId?: Maybe<Scalars['ID']>;
  mfrNumber?: Maybe<Scalars['String']>;
  modifiedById: Scalars['ID'];
  preferredVendorId?: Maybe<Scalars['ID']>;
  sellable: Scalars['Boolean'];
  standardPrice?: Maybe<Money>;
  upc?: Maybe<Scalars['String']>;
};

export type InventoryItemConnection = {
  __typename?: 'InventoryItemConnection';
  edges: Array<InventoryItemEdge>;
  pageInfo: PageInfo;
};

export type InventoryItemEdge = {
  __typename?: 'InventoryItemEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: InventoryItem;
};

export type InventoryItemSnapshot = ItemSnapshot & {
  __typename?: 'InventoryItemSnapshot';
  dateCreated: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  itemType: SnapshotItemType;
  mfrNumber: Scalars['String'];
};

export type InventoryLocation = Node & {
  __typename?: 'InventoryLocation';
  branch: EsBranch;
  branchId: Scalars['ID'];
  companyId: Scalars['ID'];
  defaultLocation: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InventoryLocationConnection = {
  __typename?: 'InventoryLocationConnection';
  edges: Array<InventoryLocationEdge>;
  pageInfo: PageInfo;
};

export type InventoryLocationEdge = {
  __typename?: 'InventoryLocationEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: InventoryLocation;
};

export type InventoryPagingInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum InventoryPermissionV1 {
  CanAdjustReceivedPurchaseOrderLineItemsByBranchId = 'CAN_ADJUST_RECEIVED_PURCHASE_ORDER_LINE_ITEMS_BY_BRANCH_ID',
  CanApprovePartsOnWorkOrderByStoreId = 'CAN_APPROVE_PARTS_ON_WORK_ORDER_BY_STORE_ID',
  CanApprovePartsRemovalFromWorkOrderByStoreId = 'CAN_APPROVE_PARTS_REMOVAL_FROM_WORK_ORDER_BY_STORE_ID',
  CanApprovePartsRentalByStoreId = 'CAN_APPROVE_PARTS_RENTAL_BY_STORE_ID',
  CanApprovePartsRentalReturnByStoreId = 'CAN_APPROVE_PARTS_RENTAL_RETURN_BY_STORE_ID',
  CanApprovePartsReturnByStoreId = 'CAN_APPROVE_PARTS_RETURN_BY_STORE_ID',
  CanApprovePartsTransferByStoreId = 'CAN_APPROVE_PARTS_TRANSFER_BY_STORE_ID',
  CanApprovePurchaseOrderByBranchId = 'CAN_APPROVE_PURCHASE_ORDER_BY_BRANCH_ID',
  CanApprovePurchaseOrderByStoreId = 'CAN_APPROVE_PURCHASE_ORDER_BY_STORE_ID',
  CanArchiveStoreByStoreId = 'CAN_ARCHIVE_STORE_BY_STORE_ID',
  CanAssignExternalAppId = 'CAN_ASSIGN_EXTERNAL_APP_ID',
  CanBulkImport = 'CAN_BULK_IMPORT',
  CanCancelPartLossByStoreId = 'CAN_CANCEL_PART_LOSS_BY_STORE_ID',
  CanCancelPartObsoleteByStoreId = 'CAN_CANCEL_PART_OBSOLETE_BY_STORE_ID',
  CanCancelPartsOnWorkOrderByStoreId = 'CAN_CANCEL_PARTS_ON_WORK_ORDER_BY_STORE_ID',
  CanCancelPartsRemovalFromWorkOrderByStoreId = 'CAN_CANCEL_PARTS_REMOVAL_FROM_WORK_ORDER_BY_STORE_ID',
  CanCancelPartsRentalByStoreId = 'CAN_CANCEL_PARTS_RENTAL_BY_STORE_ID',
  CanCancelPartsRentalReturnByStoreId = 'CAN_CANCEL_PARTS_RENTAL_RETURN_BY_STORE_ID',
  CanCancelPartsReturnByStoreId = 'CAN_CANCEL_PARTS_RETURN_BY_STORE_ID',
  CanCancelPartsTransferByStoreId = 'CAN_CANCEL_PARTS_TRANSFER_BY_STORE_ID',
  CanCancelPurchaseOrderByStoreId = 'CAN_CANCEL_PURCHASE_ORDER_BY_STORE_ID',
  CanCancelReservationByStoreId = 'CAN_CANCEL_RESERVATION_BY_STORE_ID',
  CanCancelRetailSaleByStoreId = 'CAN_CANCEL_RETAIL_SALE_BY_STORE_ID',
  CanCancelRetailSaleReturnByStoreId = 'CAN_CANCEL_RETAIL_SALE_RETURN_BY_STORE_ID',
  CanCompletePartsTransferByStoreId = 'CAN_COMPLETE_PARTS_TRANSFER_BY_STORE_ID',
  CanCompletePurchaseOrderByStoreId = 'CAN_COMPLETE_PURCHASE_ORDER_BY_STORE_ID',
  CanConvertPartsByStoreId = 'CAN_CONVERT_PARTS_BY_STORE_ID',
  CanCreateChildStoreByParentStoreId = 'CAN_CREATE_CHILD_STORE_BY_PARENT_STORE_ID',
  CanCreateDecrementAdjustmentByStoreId = 'CAN_CREATE_DECREMENT_ADJUSTMENT_BY_STORE_ID',
  CanCreateDemandRequestByStoreId = 'CAN_CREATE_DEMAND_REQUEST_BY_STORE_ID',
  CanCreateIncrementAdjustmentByStoreId = 'CAN_CREATE_INCREMENT_ADJUSTMENT_BY_STORE_ID',
  CanCreatePart = 'CAN_CREATE_PART',
  CanCreatePartCategory = 'CAN_CREATE_PART_CATEGORY',
  CanCreatePartNumberForProvider = 'CAN_CREATE_PART_NUMBER_FOR_PROVIDER',
  CanCreatePriceList = 'CAN_CREATE_PRICE_LIST',
  CanCreateProductClass = 'CAN_CREATE_PRODUCT_CLASS',
  CanCreateProvider = 'CAN_CREATE_PROVIDER',
  CanCreateReservationByStoreId = 'CAN_CREATE_RESERVATION_BY_STORE_ID',
  CanCreateTopLevelStore = 'CAN_CREATE_TOP_LEVEL_STORE',
  CanCreateUnverifiedPart = 'CAN_CREATE_UNVERIFIED_PART',
  CanCreateUnverifiedProvider = 'CAN_CREATE_UNVERIFIED_PROVIDER',
  CanDeletePart = 'CAN_DELETE_PART',
  CanDeletePartNumberForProvider = 'CAN_DELETE_PART_NUMBER_FOR_PROVIDER',
  CanDeletePriceList = 'CAN_DELETE_PRICE_LIST',
  CanDeleteProvider = 'CAN_DELETE_PROVIDER',
  CanDeletePurchaseOrderByBranchId = 'CAN_DELETE_PURCHASE_ORDER_BY_BRANCH_ID',
  CanDeleteReceivedPurchaseOrderByBranchId = 'CAN_DELETE_RECEIVED_PURCHASE_ORDER_BY_BRANCH_ID',
  CanEditAllPermissions = 'CAN_EDIT_ALL_PERMISSIONS',
  CanEditDemandRequestByStoreId = 'CAN_EDIT_DEMAND_REQUEST_BY_STORE_ID',
  CanEditPart = 'CAN_EDIT_PART',
  CanEditPartCategory = 'CAN_EDIT_PART_CATEGORY',
  CanEditPriceList = 'CAN_EDIT_PRICE_LIST',
  CanEditProvider = 'CAN_EDIT_PROVIDER',
  CanEditReceivedPurchaseOrderByBranchId = 'CAN_EDIT_RECEIVED_PURCHASE_ORDER_BY_BRANCH_ID',
  CanEditStoreByStoreId = 'CAN_EDIT_STORE_BY_STORE_ID',
  CanEditStorePartsInfoByStoreId = 'CAN_EDIT_STORE_PARTS_INFO_BY_STORE_ID',
  CanInitializeCompany = 'CAN_INITIALIZE_COMPANY',
  CanManagePurchaseLineItemsByBranchId = 'CAN_MANAGE_PURCHASE_LINE_ITEMS_BY_BRANCH_ID',
  CanMarkPartGloballyVerified = 'CAN_MARK_PART_GLOBALLY_VERIFIED',
  CanMarkProviderGloballyVerified = 'CAN_MARK_PROVIDER_GLOBALLY_VERIFIED',
  CanMergeGloballyVerifiedProducts = 'CAN_MERGE_GLOBALLY_VERIFIED_PRODUCTS',
  CanMergeParts = 'CAN_MERGE_PARTS',
  CanMergeProviders = 'CAN_MERGE_PROVIDERS',
  CanOverrideWeightedAverageCostByStoreId = 'CAN_OVERRIDE_WEIGHTED_AVERAGE_COST_BY_STORE_ID',
  CanPurchasePartsForWorkOrderByStoreId = 'CAN_PURCHASE_PARTS_FOR_WORK_ORDER_BY_STORE_ID',
  CanRecordPartLossByStoreId = 'CAN_RECORD_PART_LOSS_BY_STORE_ID',
  CanRecordPartObsoleteByStoreId = 'CAN_RECORD_PART_OBSOLETE_BY_STORE_ID',
  CanRecordRetailSaleByStoreId = 'CAN_RECORD_RETAIL_SALE_BY_STORE_ID',
  CanRecordRetailSaleReturnByStoreId = 'CAN_RECORD_RETAIL_SALE_RETURN_BY_STORE_ID',
  CanRemoveExternalAppId = 'CAN_REMOVE_EXTERNAL_APP_ID',
  CanRequestPartsOnWorkOrderByStoreId = 'CAN_REQUEST_PARTS_ON_WORK_ORDER_BY_STORE_ID',
  CanRequestPartsRemovalFromWorkOrderByStoreId = 'CAN_REQUEST_PARTS_REMOVAL_FROM_WORK_ORDER_BY_STORE_ID',
  CanRevertBulkImport = 'CAN_REVERT_BULK_IMPORT',
  CanSubmitPartsRentalByStoreId = 'CAN_SUBMIT_PARTS_RENTAL_BY_STORE_ID',
  CanSubmitPartsRentalReturnByStoreId = 'CAN_SUBMIT_PARTS_RENTAL_RETURN_BY_STORE_ID',
  CanSubmitPartsReturnByStoreId = 'CAN_SUBMIT_PARTS_RETURN_BY_STORE_ID',
  CanSubmitPartsTransferByStoreId = 'CAN_SUBMIT_PARTS_TRANSFER_BY_STORE_ID',
  CanSubmitPurchaseOrderByBranchId = 'CAN_SUBMIT_PURCHASE_ORDER_BY_BRANCH_ID',
  CanSubmitPurchaseOrderByStoreId = 'CAN_SUBMIT_PURCHASE_ORDER_BY_STORE_ID',
  CanUpdateProductClass = 'CAN_UPDATE_PRODUCT_CLASS',
  CanViewCostCapture = 'CAN_VIEW_COST_CAPTURE',
  CanViewInventory = 'CAN_VIEW_INVENTORY',
  CanViewPart = 'CAN_VIEW_PART'
}

export enum InventoryReceivedStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type InventoryStore = Node & {
  __typename?: 'InventoryStore';
  branchId?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  fullyQualifiedStoreName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type InventoryStoreFullyQualifiedStoreNameArgs = {
  delimiter?: InputMaybe<Scalars['String']>;
};

export type InventoryStoreConnection = {
  __typename?: 'InventoryStoreConnection';
  edges: Array<InventoryStoreEdge>;
  pageInfo: PageInfo;
};

export type InventoryStoreEdge = {
  __typename?: 'InventoryStoreEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: InventoryStore;
};

export type Item = {
  buyable: Scalars['Boolean'];
  companyId: Scalars['ID'];
  createdById: Scalars['ID'];
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  duplicateOfId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemType: ItemType;
  modifiedById: Scalars['ID'];
  preferredVendorId?: Maybe<Scalars['ID']>;
  sellable: Scalars['Boolean'];
  standardPrice?: Maybe<Money>;
};

export type ItemSnapshot = {
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  itemType: SnapshotItemType;
};

export enum ItemType {
  Inventory = 'INVENTORY',
  NonInventory = 'NON_INVENTORY',
  Service = 'SERVICE'
}

export type LineItemAdjustmentFields = {
  __typename?: 'LineItemAdjustmentFields';
  pricePerUnit?: Maybe<ChangeState>;
  purchaseOrderLineItemId: Scalars['String'];
  quantity?: Maybe<ChangeState>;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MatchedPurchaseTransaction = Node & {
  __typename?: 'MatchedPurchaseTransaction';
  dateCreated: Scalars['DateTime'];
  dateMatched: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
  matchedByUserId: Scalars['ID'];
  purchase?: Maybe<Purchase>;
  purchaseId: Scalars['Int'];
  purchaseTransactionId: Scalars['ID'];
  wasAutoMatched: Scalars['Boolean'];
};

export type MatchTransactionInput = {
  purchaseId: Scalars['ID'];
  purchaseTransactionId: Scalars['ID'];
};

export type MatchTransactionResult = MutationResult & {
  __typename?: 'MatchTransactionResult';
  matchedTransaction?: Maybe<MatchedPurchaseTransaction>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** A type for dealing with currency following the ISO 4217 standard. */
export type Money = {
  __typename?: 'Money';
  amount: Scalars['Decimal'];
  currencyCode: CurrencyCode;
};

/** An input type for dealing with currency following the ISO 4217 standard. */
export type MoneyInput = {
  amount: Scalars['Decimal'];
  currencyCode: CurrencyCode;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Used for Expenses. If you are adding a submitter for the old CostCapture mobile app, use createAuthorizedSubmitter() instead. */
  addAuthorizedSubmitter: AddAuthorizedSubmitterResult;
  approvePurchaseOrder: ApprovePurchaseOrderResult;
  archivePurchaseOrder: ArchivePurchaseOrderResult;
  assignItemsToUnopenedPurchaseOrder: AssignItemsToUnopenedPurchaseOrderResult;
  closePurchaseOrder: ClosePurchaseOrderResult;
  /** @deprecated This is used for the old CostCapture mobile app. For Expenses, use addAuthorizedSubmitter() instead. */
  createAuthorizedSubmitter: CreateAuthorizedSubmitterResult;
  createExternalPurchaseOrder: CreateExternalPurchaseOrderResult;
  createNonInventoryItem: CreateNonInventoryItemResult;
  createPriceList: CreatePriceListResult;
  createPurchase: CreatePurchaseResult;
  createPurchaseOrder: CreatePurchaseOrderResult;
  createPurchaseOrderReceiver: CreatePurchaseOrderReceiverResult;
  createPurchaseOrderReceiverAdjustment: CreateBulkReceiversAdjustmentResult;
  createPurchaseReceipt: CreatePurchaseReceiptResult;
  createServiceItem: CreateServiceItemResult;
  deleteAllPurchaseLineItems: DeleteAllPurchaseLineItemsResult;
  /** @deprecated This is used for the old CostCapture mobile app. For Expenses, use removeAuthorizedSubmitter() instead. */
  deleteAuthorizedSubmitter: DeleteAuthorizedSubmitterResult;
  enrollPurchaseAccount: EnrollPurchaseAccountResult;
  fullyReceivePurchase: FullyReceivePurchaseResult;
  matchTransaction: MatchTransactionResult;
  /** Used for Expenses. If you are adding a submitter for the old CostCapture mobile app, use deleteAuthorizedSubmitter() instead. */
  removeAuthorizedSubmitter: RemoveAuthorizedSubmitterResult;
  reopenPurchaseOrder: ReopenPurchaseOrderResult;
  sendApprovePurchaseOrderEmail: SendApprovePurchaseOrderEmailResult;
  setIsCostCaptureLocation: UpdatedBranchResult;
  setStandardPriceForItem: SetStandardPriceForItemResult;
  unarchivePurchaseOrder: UnarchivePurchaseOrderResult;
  updateNonInventoryItem: UpdateNonInventoryItemResult;
  updatePurchase: UpdatePurchaseResult;
  updatePurchaseOrder: UpdatePurchaseOrderResult;
};


export type MutationAddAuthorizedSubmitterArgs = {
  input: AddAuthorizedSubmitterInput;
};


export type MutationApprovePurchaseOrderArgs = {
  input: ApprovePurchaseOrderInput;
};


export type MutationArchivePurchaseOrderArgs = {
  input: ArchivePurchaseOrderInput;
};


export type MutationAssignItemsToUnopenedPurchaseOrderArgs = {
  input: AssignItemsToUnopenedPurchaseOrderInput;
};


export type MutationClosePurchaseOrderArgs = {
  input: ClosePurchaseOrderInput;
};


export type MutationCreateAuthorizedSubmitterArgs = {
  input: CreateAuthorizedSubmitterInput;
};


export type MutationCreateExternalPurchaseOrderArgs = {
  input: CreateExternalPurchaseOrderInput;
};


export type MutationCreateNonInventoryItemArgs = {
  input: CreateNonInventoryItemInput;
};


export type MutationCreatePriceListArgs = {
  input: CreatePriceListInput;
};


export type MutationCreatePurchaseArgs = {
  input: CreatePurchaseInput;
};


export type MutationCreatePurchaseOrderArgs = {
  input: CreatePurchaseOrderInput;
};


export type MutationCreatePurchaseOrderReceiverArgs = {
  input: CreatePurchaseOrderReceiverInput;
};


export type MutationCreatePurchaseOrderReceiverAdjustmentArgs = {
  input: CreateBulkReceiversAdjustmentInput;
};


export type MutationCreatePurchaseReceiptArgs = {
  input: CreatePurchaseReceiptInput;
};


export type MutationCreateServiceItemArgs = {
  input: CreateServiceItemInput;
};


export type MutationDeleteAllPurchaseLineItemsArgs = {
  input: DeleteAllPurchaseLineItemsInput;
};


export type MutationDeleteAuthorizedSubmitterArgs = {
  input: DeleteAuthorizedSubmitterInput;
};


export type MutationEnrollPurchaseAccountArgs = {
  input: EnrollPurchaseAccountInput;
};


export type MutationFullyReceivePurchaseArgs = {
  input: FullyReceivePurchaseInput;
};


export type MutationMatchTransactionArgs = {
  input: MatchTransactionInput;
};


export type MutationRemoveAuthorizedSubmitterArgs = {
  input: RemoveAuthorizedSubmitterInput;
};


export type MutationReopenPurchaseOrderArgs = {
  input: ReopenPurchaseOrderInput;
};


export type MutationSendApprovePurchaseOrderEmailArgs = {
  input: SendApprovePurchaseOrderEmailInput;
};


export type MutationSetIsCostCaptureLocationArgs = {
  input: SetIsCostCaptureLocationInput;
};


export type MutationSetStandardPriceForItemArgs = {
  input: SetStandardPriceForItemInput;
};


export type MutationUnarchivePurchaseOrderArgs = {
  input: UnarchivePurchaseOrderInput;
};


export type MutationUpdateNonInventoryItemArgs = {
  input: UpdateNonInventoryItemInput;
};


export type MutationUpdatePurchaseArgs = {
  input: UpdatePurchaseInput;
};


export type MutationUpdatePurchaseOrderArgs = {
  input: UpdatePurchaseOrderInput;
};

export type MutationResult = {
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Node = {
  id: Scalars['ID'];
};

export type NonInventoryItem = Item & Node & {
  __typename?: 'NonInventoryItem';
  allocationType?: Maybe<NonInventoryItemAllocation>;
  buyable: Scalars['Boolean'];
  companyId: Scalars['ID'];
  createdById: Scalars['ID'];
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  duplicateOfId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAllocationRequired: Scalars['Boolean'];
  itemType: ItemType;
  modifiedById: Scalars['ID'];
  name: Scalars['String'];
  preferredVendorId?: Maybe<Scalars['ID']>;
  sellable: Scalars['Boolean'];
  standardPrice?: Maybe<Money>;
};

export enum NonInventoryItemAllocation {
  Invoice = 'INVOICE',
  WorkOrder = 'WORK_ORDER'
}

export type NonInventoryItemConnection = {
  __typename?: 'NonInventoryItemConnection';
  /** Array of edges. */
  edges: Array<NonInventoryItemEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type NonInventoryItemEdge = {
  __typename?: 'NonInventoryItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the NonInventoryItem */
  node: NonInventoryItem;
};

export type NonInventoryItemFilter = {
  and?: InputMaybe<Array<NonInventoryItemFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<NonInventoryItemFilter>>;
};

export type NonInventoryItemSnapshot = ItemSnapshot & {
  __typename?: 'NonInventoryItemSnapshot';
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  itemType: SnapshotItemType;
  name: Scalars['String'];
};

export type NonInventoryItemSort = {
  direction: SortDirection;
  field: NonInventoryItemSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum NonInventoryItemSortFields {
  Name = 'name'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']>;
};

export type PoFieldTypes = {
  __typename?: 'POFieldTypes';
  after?: Maybe<EditedFieldResolverUnion>;
  before?: Maybe<EditedFieldResolverUnion>;
  field: Scalars['String'];
};

export type PoLineItemFieldChanges = {
  __typename?: 'POLineItemFieldChanges';
  allocationSnapshotId: ChangeState;
  description: ChangeState;
  editedItemSnapshotId: ChangeState;
  memo: ChangeState;
  pricePerUnit: ChangeState;
  quantity: ChangeState;
};

export type PoLineItemFieldTypes = {
  __typename?: 'POLineItemFieldTypes';
  after?: Maybe<EditedLineItemFieldResolverUnion>;
  before?: Maybe<EditedLineItemFieldResolverUnion>;
  field: Scalars['String'];
};

export type PriceList = Node & {
  __typename?: 'PriceList';
  companyId: Scalars['ID'];
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedById: Scalars['ID'];
  name: Scalars['String'];
};

export type ProcurementsUser = {
  __typename?: 'ProcurementsUser';
  companyId: Scalars['ID'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

export type Purchase = {
  __typename?: 'Purchase';
  accountType: PurchaseAccountType;
  businessDepartmentSnapshot?: Maybe<BusinessDepartmentSnapshot>;
  businessDepartmentSnapshotId?: Maybe<Scalars['ID']>;
  businessExpenseLineSnapshot?: Maybe<BusinessExpenseLineSnapshot>;
  businessExpenseLineSnapshotId?: Maybe<Scalars['ID']>;
  businessSubDepartmentSnapshot?: Maybe<BusinessSubDepartmentSnapshot>;
  businessSubDepartmentSnapshotId?: Maybe<Scalars['ID']>;
  grandTotal: Money;
  id: Scalars['Int'];
  imageUrls: Array<Scalars['String']>;
  inventoryReceivedStatus?: Maybe<InventoryReceivedStatus>;
  isDisputed: Scalars['Boolean'];
  isPersonalExpense: Scalars['Boolean'];
  isReturn: Scalars['Boolean'];
  lineItems: Array<PurchaseLineItem>;
  marketId: Scalars['Int'];
  matchedPurchaseTransaction?: Maybe<MatchedPurchaseTransaction>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  notes: Scalars['String'];
  purchaseAccount?: Maybe<PurchaseAccount>;
  purchasedAt: Scalars['DateTime'];
  purchaseUser?: Maybe<ProcurementsUser>;
  purchaseUserId: Scalars['Int'];
  submittedAt: Scalars['DateTime'];
  submittedByUser?: Maybe<ProcurementsUser>;
  submittedByUserId: Scalars['Int'];
  unofficialVendorName?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['Int']>;
  vendorSnapshot?: Maybe<VendorSnapshot>;
};

export type PurchaseAccount = Node & {
  __typename?: 'PurchaseAccount';
  accountType: Scalars['String'];
  authorizedSubmitters?: Maybe<Array<AuthorizedSubmitterV2>>;
  closedDate?: Maybe<Scalars['DateTime']>;
  companyId: Scalars['ID'];
  enrollmentDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isClosed: Scalars['Boolean'];
  lastFour?: Maybe<Scalars['String']>;
  user: ProcurementsUser;
  userId: Scalars['ID'];
};

export type PurchaseAccountFilter = {
  and?: InputMaybe<Array<PurchaseAccountFilter>>;
  closedDate?: InputMaybe<DateFieldComparison>;
  enrollmentDate?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<PurchaseAccountFilter>>;
};

export type PurchaseAccountOffsetPaging = {
  /** How many items to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** The index of the item to start after. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type PurchaseAccountsConnection = {
  __typename?: 'PurchaseAccountsConnection';
  edges: Array<PurchaseAccountsEdge>;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type PurchaseAccountsEdge = {
  __typename?: 'PurchaseAccountsEdge';
  node: PurchaseAccount;
};

export type PurchaseAccountSort = {
  direction: SortDirection;
  field: PurchaseAccountSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PurchaseAccountSortFields {
  ClosedDate = 'closedDate',
  EnrollmentDate = 'enrollmentDate'
}

export enum PurchaseAccountType {
  Amex = 'AMEX',
  Central = 'CENTRAL',
  Citi = 'CITI',
  Fuel = 'FUEL'
}

export type PurchaseAccountTypeFilterComparison = {
  eq?: InputMaybe<PurchaseAccountType>;
  gt?: InputMaybe<PurchaseAccountType>;
  gte?: InputMaybe<PurchaseAccountType>;
  iLike?: InputMaybe<PurchaseAccountType>;
  in?: InputMaybe<Array<PurchaseAccountType>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<PurchaseAccountType>;
  lt?: InputMaybe<PurchaseAccountType>;
  lte?: InputMaybe<PurchaseAccountType>;
  neq?: InputMaybe<PurchaseAccountType>;
  notILike?: InputMaybe<PurchaseAccountType>;
  notIn?: InputMaybe<Array<PurchaseAccountType>>;
  notLike?: InputMaybe<PurchaseAccountType>;
};

export type PurchaseConnection = {
  __typename?: 'PurchaseConnection';
  /** Array of edges. */
  edges: Array<PurchaseEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Purchase */
  node: Purchase;
};

export type PurchaseFilter = {
  accountType?: InputMaybe<PurchaseAccountTypeFilterComparison>;
  and?: InputMaybe<Array<PurchaseFilter>>;
  id?: InputMaybe<PurchaseIdFilterComparison>;
  inventoryReceivedStatus?: InputMaybe<PurchaseInventoryReceivedStatusFilterComparison>;
  isDisputed?: InputMaybe<BooleanFieldComparison>;
  isReturn?: InputMaybe<BooleanFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  modifiedAt?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<PurchaseFilter>>;
  purchasedAt?: InputMaybe<DateFieldComparison>;
  purchaseUserId?: InputMaybe<IntFieldComparison>;
  submittedAt?: InputMaybe<DateFieldComparison>;
  vendorId?: InputMaybe<IntFieldComparison>;
};

export type PurchaseIdFilterComparison = {
  eq?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
};

export type PurchaseInventoryReceivedStatusFilterComparison = {
  eq?: InputMaybe<InventoryReceivedStatus>;
  in?: InputMaybe<Array<InventoryReceivedStatus>>;
  notIn?: InputMaybe<Array<InventoryReceivedStatus>>;
};

export type PurchaseLineItem = {
  __typename?: 'PurchaseLineItem';
  allocationId?: Maybe<Scalars['ID']>;
  allocationSnapshot?: Maybe<AllocationSnapshot>;
  allocationSnapshotId?: Maybe<Scalars['String']>;
  allocationType: PurchaseOrderLineItemAllocation;
  description: Scalars['String'];
  id: Scalars['ID'];
  item: Item;
  itemId: Scalars['ID'];
  itemSnapshot?: Maybe<ItemSnapshot>;
  memo?: Maybe<Scalars['String']>;
  pricePerUnit: Money;
  purchaseId: Scalars['ID'];
  quantity: Scalars['Float'];
  totalAccepted: Scalars['Int'];
  totalRejected: Scalars['Int'];
};

export type PurchaseLineItemEdge = {
  __typename?: 'PurchaseLineItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the PurchaseLineItem */
  node: PurchaseLineItem;
};

export type PurchaseOffsetPaging = {
  /** How many items to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** The index of the item to start after. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type PurchaseOrder = Node & {
  __typename?: 'PurchaseOrder';
  amountApproved?: Maybe<Money>;
  approvedBy: ProcurementsUser;
  approvers: Array<PurchaseOrderApprover>;
  companyId: Scalars['ID'];
  costCenterSnapshot?: Maybe<CostCenterSnapshot>;
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  deliverToId: Scalars['String'];
  deliverToSnapshot?: Maybe<DeliverToSnapshot>;
  id: Scalars['ID'];
  inventoryLocation: InventoryLocation;
  isExternal: Scalars['Boolean'];
  lineItems: Array<PurchaseOrderLineItem>;
  modifiedById: Scalars['ID'];
  promiseDate?: Maybe<Scalars['DateTime']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
  requestingBranchId: Scalars['String'];
  status: PurchaseOrderStatus;
  storeId?: Maybe<Scalars['ID']>;
  totalReceivableItemsAccepted: Scalars['Int'];
  totalReceivableItemsRejected: Scalars['Int'];
  totalReceivableItemsRequested: Scalars['Int'];
  totalRequestedCost: Money;
  totalRequestedCostV2: Money;
  vendor: Vendor;
  vendorId: Scalars['ID'];
  vendorSnapshot: VendorSnapshot;
};

export type PurchaseOrderActivityFeedEvent = PurchaseOrderCreatedEvent | PurchaseOrderItemsReceivedEvent;

export type PurchaseOrderApprover = Node & {
  __typename?: 'PurchaseOrderApprover';
  approvedBy: ProcurementsUser;
  approvedById: Scalars['ID'];
  dateApproved?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  purchaseOrderId: Scalars['ID'];
};

export type PurchaseOrderApproverEdge = {
  __typename?: 'PurchaseOrderApproverEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the PurchaseOrderApprover */
  node: PurchaseOrderApprover;
};

export type PurchaseOrderConnection = {
  __typename?: 'PurchaseOrderConnection';
  edges: Array<PurchaseOrderEdge>;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type PurchaseOrderCreatedByIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
};

export type PurchaseOrderCreatedEvent = {
  __typename?: 'PurchaseOrderCreatedEvent';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  purchaseOrder: PurchaseOrder;
};

export type PurchaseOrderEdge = {
  __typename?: 'PurchaseOrderEdge';
  node: PurchaseOrder;
};

export type PurchaseOrderEventLog = {
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
};

export type PurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<PurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<PurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type PurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: PurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export enum PurchaseOrderEventLogTypes {
  Adjusted = 'ADJUSTED',
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Created = 'CREATED',
  Edited = 'EDITED',
  ItemsReceived = 'ITEMS_RECEIVED',
  Reopened = 'REOPENED'
}

export type PurchaseOrderEventLogTypesFilterComparison = {
  eq?: InputMaybe<PurchaseOrderEventLogTypes>;
  gt?: InputMaybe<PurchaseOrderEventLogTypes>;
  gte?: InputMaybe<PurchaseOrderEventLogTypes>;
  iLike?: InputMaybe<PurchaseOrderEventLogTypes>;
  in?: InputMaybe<Array<PurchaseOrderEventLogTypes>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<PurchaseOrderEventLogTypes>;
  lt?: InputMaybe<PurchaseOrderEventLogTypes>;
  lte?: InputMaybe<PurchaseOrderEventLogTypes>;
  neq?: InputMaybe<PurchaseOrderEventLogTypes>;
  notILike?: InputMaybe<PurchaseOrderEventLogTypes>;
  notIn?: InputMaybe<Array<PurchaseOrderEventLogTypes>>;
  notLike?: InputMaybe<PurchaseOrderEventLogTypes>;
};

export type PurchaseOrderFilter = {
  and?: InputMaybe<Array<PurchaseOrderFilter>>;
  createdById?: InputMaybe<PurchaseOrderCreatedByIdFilterComparison>;
  dateArchived?: InputMaybe<DateFieldComparison>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  dateUpdated?: InputMaybe<DateFieldComparison>;
  deliverToId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<PurchaseOrderIdFilterComparison>;
  or?: InputMaybe<Array<PurchaseOrderFilter>>;
  promiseDate?: InputMaybe<DateFieldComparison>;
  purchaseOrderNumber?: InputMaybe<StringFieldComparison>;
  reference?: InputMaybe<StringFieldComparison>;
  requestingBranchId?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<PurchaseOrderStatusFilterComparison>;
  storeId?: InputMaybe<IdFilterComparison>;
};

export type PurchaseOrderIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']>;
};

export type PurchaseOrderItemsReceivedEvent = {
  __typename?: 'PurchaseOrderItemsReceivedEvent';
  dateReceived: Scalars['DateTime'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderReceiver: PurchaseOrderReceiver;
};

export type PurchaseOrderLineItem = {
  __typename?: 'PurchaseOrderLineItem';
  allocationId?: Maybe<Scalars['ID']>;
  allocationSnapshot?: Maybe<AllocationSnapshot>;
  allocationSnapshotId?: Maybe<Scalars['String']>;
  allocationType?: Maybe<PurchaseOrderLineItemAllocation>;
  description: Scalars['String'];
  id: Scalars['ID'];
  item: Item;
  itemId: Scalars['ID'];
  itemSnapshot?: Maybe<ItemSnapshot>;
  memo?: Maybe<Scalars['String']>;
  pricePerUnit: Money;
  quantity: Scalars['Float'];
  totalAccepted: Scalars['Int'];
  totalRejected: Scalars['Int'];
};

export enum PurchaseOrderLineItemAllocation {
  Invoice = 'INVOICE',
  Stock = 'STOCK',
  WorkOrder = 'WORK_ORDER'
}

export type PurchaseOrderLineItemConnection = {
  __typename?: 'PurchaseOrderLineItemConnection';
  /** Array of edges. */
  edges: Array<PurchaseOrderLineItemEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type PurchaseOrderLineItemEdge = {
  __typename?: 'PurchaseOrderLineItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the PurchaseOrderLineItem */
  node: PurchaseOrderLineItem;
};

export type PurchaseOrderLineItemFilter = {
  and?: InputMaybe<Array<PurchaseOrderLineItemFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<PurchaseOrderLineItemFilter>>;
};

export type PurchaseOrderLineItemSort = {
  direction: SortDirection;
  field: PurchaseOrderLineItemSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PurchaseOrderLineItemSortFields {
  Id = 'id'
}

export type PurchaseOrderLineItemStoreReceipt = {
  __typename?: 'PurchaseOrderLineItemStoreReceipt';
  acceptedQuantity: Scalars['Int'];
  location?: Maybe<InventoryLocation>;
  purchaseOrderLineItem: PurchaseOrderLineItem;
  purchaseOrderLineItemId: Scalars['ID'];
  rejectedQuantity: Scalars['Int'];
  storeId?: Maybe<Scalars['ID']>;
};

export type PurchaseOrderOffsetPaging = {
  /** How many items to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** The index of the item to start after. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type PurchaseOrderReceiver = Node & {
  __typename?: 'PurchaseOrderReceiver';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  dateReceived: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
  inventoryLocation: InventoryLocation;
  modifiedBy: ProcurementsUser;
  modifiedById: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  purchaseOrderId: Scalars['ID'];
  receiverItems: Array<PurchaseOrderReceiverItem>;
  receiverType: PurchaseOrderReceiverType;
  storeId?: Maybe<Scalars['ID']>;
  transactionId?: Maybe<Scalars['ID']>;
};

export type PurchaseOrderReceiverConnection = {
  __typename?: 'PurchaseOrderReceiverConnection';
  /** Array of edges. */
  edges: Array<PurchaseOrderReceiverEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type PurchaseOrderReceiverEdge = {
  __typename?: 'PurchaseOrderReceiverEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the PurchaseOrderReceiver */
  node: PurchaseOrderReceiver;
};

export type PurchaseOrderReceiverFilter = {
  and?: InputMaybe<Array<PurchaseOrderReceiverFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  dateUpdated?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<PurchaseOrderReceiverFilter>>;
};

export type PurchaseOrderReceiverItem = {
  __typename?: 'PurchaseOrderReceiverItem';
  acceptedQuantity: Scalars['Int'];
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedById: Scalars['ID'];
  pricePerUnit: Money;
  purchaseOrderLineItem: PurchaseOrderLineItem;
  purchaseOrderLineItemId: Scalars['String'];
  purchaseOrderReceiverId: Scalars['String'];
  rejectedQuantity: Scalars['Int'];
};

export type PurchaseOrderReceiverItemEdge = {
  __typename?: 'PurchaseOrderReceiverItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the PurchaseOrderReceiverItem */
  node: PurchaseOrderReceiverItem;
};

export type PurchaseOrderReceiverSort = {
  direction: SortDirection;
  field: PurchaseOrderReceiverSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PurchaseOrderReceiverSortFields {
  DateCreated = 'dateCreated',
  DateUpdated = 'dateUpdated'
}

export enum PurchaseOrderReceiverType {
  Adjustment = 'ADJUSTMENT',
  Invoice = 'INVOICE',
  Receipt = 'RECEIPT'
}

export type PurchaseOrderSort = {
  direction: SortDirection;
  field: PurchaseOrderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PurchaseOrderSortFields {
  CreatedById = 'createdById',
  DateArchived = 'dateArchived',
  DateCreated = 'dateCreated',
  DateUpdated = 'dateUpdated',
  DeliverToId = 'deliverToId',
  Id = 'id',
  PromiseDate = 'promiseDate',
  PurchaseOrderNumber = 'purchaseOrderNumber',
  Reference = 'reference',
  RequestingBranchId = 'requestingBranchId',
  Status = 'status',
  StoreId = 'storeId'
}

export enum PurchaseOrderStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  NeedsApproval = 'NEEDS_APPROVAL',
  Open = 'OPEN'
}

export type PurchaseOrderStatusFilterComparison = {
  eq?: InputMaybe<PurchaseOrderStatus>;
  in?: InputMaybe<Array<PurchaseOrderStatus>>;
  notIn?: InputMaybe<Array<PurchaseOrderStatus>>;
};

export enum PurchaseQueryScope {
  Both = 'BOTH',
  V1Only = 'V1_ONLY',
  V2Only = 'V2_ONLY'
}

export type PurchaseReceipt = Node & {
  __typename?: 'PurchaseReceipt';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  dateReceived?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedBy: ProcurementsUser;
  modifiedById: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  purchaseId: Scalars['ID'];
  receiptItems: Array<PurchaseReceiptItem>;
  storeId?: Maybe<Scalars['ID']>;
  transactionId?: Maybe<Scalars['ID']>;
};

export type PurchaseReceiptItem = {
  __typename?: 'PurchaseReceiptItem';
  acceptedQuantity: Scalars['Int'];
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedBy: ProcurementsUser;
  modifiedById: Scalars['ID'];
  purchaseLineItem: PurchaseLineItem;
  purchaseLineItemId: Scalars['String'];
  purchaseReceiptId: Scalars['String'];
  rejectedQuantity: Scalars['Int'];
};

export type PurchasesConnection = {
  __typename?: 'PurchasesConnection';
  edges: Array<PurchasesEdge>;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type PurchasesEdge = {
  __typename?: 'PurchasesEdge';
  node: Purchase;
};

export type PurchaseSort = {
  direction: SortDirection;
  field: PurchaseSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PurchaseSortFields {
  AccountType = 'accountType',
  Id = 'id',
  InventoryReceivedStatus = 'inventoryReceivedStatus',
  IsDisputed = 'isDisputed',
  IsReturn = 'isReturn',
  MarketId = 'marketId',
  ModifiedAt = 'modifiedAt',
  PurchasedAt = 'purchasedAt',
  PurchaseUserId = 'purchaseUserId',
  SubmittedAt = 'submittedAt',
  VendorId = 'vendorId'
}

export type PurchaseTransaction = Node & {
  __typename?: 'PurchaseTransaction';
  acquirerReferenceNumber?: Maybe<Scalars['String']>;
  adjustments: Array<PurchaseTransactionAdjustment>;
  amount: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  externalTransactionId: Scalars['String'];
  id: Scalars['ID'];
  isCredit: Scalars['Boolean'];
  isMatchedToPurchase: Scalars['Boolean'];
  isPurchaseVerified: Scalars['Boolean'];
  matchedPurchaseTransaction?: Maybe<MatchedPurchaseTransaction>;
  mccCode?: Maybe<Scalars['String']>;
  mccName?: Maybe<Scalars['String']>;
  merchant: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  purchaseAccount: PurchaseAccount;
  purchaseAccountId: Scalars['String'];
  purchaseDate: Scalars['Date'];
};

export type PurchaseTransactionAdjustment = Node & {
  __typename?: 'PurchaseTransactionAdjustment';
  acquirerReferenceNumber: Scalars['String'];
  adjustedTransaction: PurchaseTransaction;
  adjustedTransactionId: Scalars['String'];
  adjustmentCode?: Maybe<Scalars['String']>;
  adjustmentDescription?: Maybe<Scalars['String']>;
  amount: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  externalTransactionId: Scalars['String'];
  id: Scalars['ID'];
  isCredit: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  postingDate: Scalars['Date'];
  purchaseDate: Scalars['Date'];
};

export type PurchaseTransactionFilter = {
  and?: InputMaybe<Array<PurchaseTransactionFilter>>;
  or?: InputMaybe<Array<PurchaseTransactionFilter>>;
  purchaseDate?: InputMaybe<DateFieldComparison>;
};

export type PurchaseTransactionOffsetPaging = {
  /** How many items to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** The index of the item to start after. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type PurchaseTransactionsConnection = {
  __typename?: 'PurchaseTransactionsConnection';
  edges: Array<PurchaseTransactionsEdge>;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type PurchaseTransactionsEdge = {
  __typename?: 'PurchaseTransactionsEdge';
  node: PurchaseTransaction;
};

export type PurchaseTransactionSort = {
  direction: SortDirection;
  field: PurchaseTransactionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PurchaseTransactionSortFields {
  PurchaseDate = 'purchaseDate'
}

export type Query = {
  __typename?: 'Query';
  adjustedPurchaseOrderEventLog?: Maybe<AdjustedPurchaseOrderEventLog>;
  adjustedPurchaseOrderEventLogs: AdjustedPurchaseOrderEventLogConnection;
  approvedPurchaseOrderEventLog?: Maybe<ApprovedPurchaseOrderEventLog>;
  approvedPurchaseOrderEventLogs: ApprovedPurchaseOrderEventLogConnection;
  authorizedSubmitters: AuthorizedSubmitterConnection;
  betaTestUserAuthorizations: BetaTestUserAuthorizationResult;
  branch?: Maybe<Branch>;
  branches: BranchConnection;
  closedPurchaseOrderEventLog?: Maybe<ClosedPurchaseOrderEventLog>;
  closedPurchaseOrderEventLogs: ClosedPurchaseOrderEventLogConnection;
  createdPurchaseOrderEventLog?: Maybe<CreatedPurchaseOrderEventLog>;
  createdPurchaseOrderEventLogs: CreatedPurchaseOrderEventLogConnection;
  deletedPurchaseOrderEventLog?: Maybe<DeletedPurchaseOrderEventLog>;
  deletedPurchaseOrderEventLogs: DeletedPurchaseOrderEventLogConnection;
  editedPurchaseOrderEventLog?: Maybe<EditedPurchaseOrderEventLog>;
  editedPurchaseOrderEventLogs: EditedPurchaseOrderEventLogConnection;
  emailedApprovers?: Maybe<Array<PurchaseOrderApprover>>;
  getSpendingLimitForCostCenter: Money;
  inventoryItems: InventoryItemConnection;
  inventoryLocation?: Maybe<InventoryLocation>;
  inventoryLocations: InventoryLocationConnection;
  inventoryStore?: Maybe<InventoryStore>;
  inventoryStores: InventoryStoreConnection;
  nonInventoryItem?: Maybe<NonInventoryItem>;
  nonInventoryItems: NonInventoryItemConnection;
  previousItemPrice?: Maybe<Money>;
  purchase?: Maybe<Purchase>;
  purchaseAccount?: Maybe<PurchaseAccount>;
  purchaseAccounts: PurchaseAccountsConnection;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderActivityFeed?: Maybe<Array<PurchaseOrderActivityFeedEvent>>;
  purchaseOrderByNumber?: Maybe<PurchaseOrder>;
  purchaseOrderEventLog?: Maybe<PurchaseOrderEventLog>;
  purchaseOrderEventLogs: Array<PurchaseOrderEventLog>;
  purchaseOrderLineItem?: Maybe<PurchaseOrderLineItem>;
  purchaseOrderLineItems: PurchaseOrderLineItemConnection;
  purchaseOrderLineItemStoreReceipts?: Maybe<Array<PurchaseOrderLineItemStoreReceipt>>;
  purchaseOrderReceiver?: Maybe<PurchaseOrderReceiver>;
  purchaseOrderReceivers: PurchaseOrderReceiverConnection;
  purchaseOrders: PurchaseOrderConnection;
  purchases: PurchasesConnection;
  purchaseTransaction?: Maybe<PurchaseTransaction>;
  purchaseTransactionAdjustment?: Maybe<PurchaseTransactionAdjustment>;
  purchaseTransactions: PurchaseTransactionsConnection;
  receivedPurchaseOrderEventLog?: Maybe<ReceivedPurchaseOrderEventLog>;
  receivedPurchaseOrderEventLogs: ReceivedPurchaseOrderEventLogConnection;
  reopenedPurchaseOrderEventLog?: Maybe<ReopenedPurchaseOrderEventLog>;
  reopenedPurchaseOrderEventLogs: ReopenedPurchaseOrderEventLogConnection;
  serviceItem?: Maybe<ServiceItem>;
  serviceItems: ServiceItemConnection;
  storeInventoryItems: StoreInventoryItemConnection;
  userAuthorizationsV1: Array<UserAuthorization>;
  userHasAccessToFeature: UserHasAccessToFeatureResult;
  userPurchases: PurchaseConnection;
  users: UserConnection;
  vendors: VendorConnection;
};


export type QueryAdjustedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryAdjustedPurchaseOrderEventLogsArgs = {
  filter?: AdjustedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<AdjustedPurchaseOrderEventLogSort>;
};


export type QueryApprovedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryApprovedPurchaseOrderEventLogsArgs = {
  filter?: ApprovedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<ApprovedPurchaseOrderEventLogSort>;
};


export type QueryAuthorizedSubmittersArgs = {
  filter?: AuthorizedSubmitterFilter;
  paging?: CursorPaging;
  sorting?: Array<AuthorizedSubmitterSort>;
};


export type QueryBranchArgs = {
  id: Scalars['ID'];
};


export type QueryBranchesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  isCostCaptureLocation?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<BranchOffsetPagingInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryClosedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryClosedPurchaseOrderEventLogsArgs = {
  filter?: ClosedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<ClosedPurchaseOrderEventLogSort>;
};


export type QueryCreatedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryCreatedPurchaseOrderEventLogsArgs = {
  filter?: CreatedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<CreatedPurchaseOrderEventLogSort>;
};


export type QueryDeletedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryDeletedPurchaseOrderEventLogsArgs = {
  filter?: DeletedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<DeletedPurchaseOrderEventLogSort>;
};


export type QueryEditedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryEditedPurchaseOrderEventLogsArgs = {
  filter?: EditedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<EditedPurchaseOrderEventLogSort>;
};


export type QueryEmailedApproversArgs = {
  purchaseOrderId: Scalars['ID'];
};


export type QueryGetSpendingLimitForCostCenterArgs = {
  id: Scalars['ID'];
};


export type QueryInventoryItemsArgs = {
  paging?: InputMaybe<CursorPaging>;
  search?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryInventoryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryInventoryLocationsArgs = {
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  inventoryLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  paging?: InputMaybe<CursorPaging>;
  permissions?: InputMaybe<Array<InventoryPermissionV1>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryInventoryStoreArgs = {
  id: Scalars['ID'];
};


export type QueryInventoryStoresArgs = {
  branchIds?: InputMaybe<Array<Scalars['Int']>>;
  onlyRoot?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<CursorPaging>;
  permissionsV1?: InputMaybe<Array<InventoryPermissionV1>>;
  search?: InputMaybe<Scalars['String']>;
  storeIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryNonInventoryItemArgs = {
  id: Scalars['ID'];
};


export type QueryNonInventoryItemsArgs = {
  filter?: NonInventoryItemFilter;
  paging?: CursorPaging;
  search?: InputMaybe<Scalars['String']>;
  sorting?: Array<NonInventoryItemSort>;
};


export type QueryPreviousItemPriceArgs = {
  branchId: Scalars['ID'];
  itemId: Scalars['ID'];
  lineItemId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};


export type QueryPurchaseArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseAccountArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseAccountsArgs = {
  filter?: InputMaybe<PurchaseAccountFilter>;
  includeAuthorizedAccounts?: Scalars['Boolean'];
  includeClosed?: Scalars['Boolean'];
  paging?: InputMaybe<PurchaseAccountOffsetPaging>;
  sorting?: InputMaybe<Array<PurchaseAccountSort>>;
};


export type QueryPurchaseOrderArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseOrderActivityFeedArgs = {
  purchaseOrderId: Scalars['ID'];
};


export type QueryPurchaseOrderByNumberArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseOrderEventLogsArgs = {
  filter?: PurchaseOrderEventLogFilter;
  sorting?: Array<PurchaseOrderEventLogSort>;
};


export type QueryPurchaseOrderLineItemArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseOrderLineItemsArgs = {
  filter?: PurchaseOrderLineItemFilter;
  paging?: CursorPaging;
  sorting?: Array<PurchaseOrderLineItemSort>;
};


export type QueryPurchaseOrderLineItemStoreReceiptsArgs = {
  purchaseOrderId: Scalars['ID'];
};


export type QueryPurchaseOrderReceiverArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseOrderReceiversArgs = {
  filter?: PurchaseOrderReceiverFilter;
  paging?: CursorPaging;
  sorting?: Array<PurchaseOrderReceiverSort>;
};


export type QueryPurchaseOrdersArgs = {
  filter?: InputMaybe<PurchaseOrderFilter>;
  paging?: InputMaybe<PurchaseOrderOffsetPaging>;
  search?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Array<PurchaseOrderSort>>;
};


export type QueryPurchasesArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  hasLineItems?: InputMaybe<Scalars['Boolean']>;
  includeScope?: InputMaybe<PurchaseQueryScope>;
  onlyExpensePurchases?: InputMaybe<Scalars['Boolean']>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<PurchaseOffsetPaging>;
  purchaseAccountId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Array<PurchaseSort>>;
};


export type QueryPurchaseTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseTransactionAdjustmentArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseTransactionsArgs = {
  filter?: InputMaybe<PurchaseTransactionFilter>;
  paging?: InputMaybe<PurchaseTransactionOffsetPaging>;
  sorting?: InputMaybe<Array<PurchaseTransactionSort>>;
};


export type QueryReceivedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryReceivedPurchaseOrderEventLogsArgs = {
  filter?: ReceivedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<ReceivedPurchaseOrderEventLogSort>;
};


export type QueryReopenedPurchaseOrderEventLogArgs = {
  id: Scalars['ID'];
};


export type QueryReopenedPurchaseOrderEventLogsArgs = {
  filter?: ReopenedPurchaseOrderEventLogFilter;
  paging?: CursorPaging;
  sorting?: Array<ReopenedPurchaseOrderEventLogSort>;
};


export type QueryServiceItemArgs = {
  id: Scalars['ID'];
};


export type QueryServiceItemsArgs = {
  filter?: ServiceItemFilter;
  paging?: CursorPaging;
  search?: InputMaybe<Scalars['String']>;
  sorting?: Array<ServiceItemSort>;
};


export type QueryStoreInventoryItemsArgs = {
  isDeadStock?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<InventoryPagingInput>;
  search?: InputMaybe<Scalars['String']>;
  storeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryUserAuthorizationsV1Args = {
  permissions: Array<InventoryPermissionV1>;
};


export type QueryUserPurchasesArgs = {
  filter?: PurchaseFilter;
  onlyExpensePurchases?: InputMaybe<Scalars['Boolean']>;
  paging?: CursorPaging;
  sorting?: Array<PurchaseSort>;
};


export type QueryUsersArgs = {
  paging?: InputMaybe<UserOffsetPagingInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryVendorsArgs = {
  paging?: InputMaybe<VendorOffsetPagingInput>;
  search?: InputMaybe<Scalars['String']>;
};

export type ReceivedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'ReceivedPurchaseOrderEventLog';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
  receivedLineItems: Array<PurchaseOrderLineItem>;
  receivedReceiverItems: Array<PurchaseOrderReceiverItem>;
  receiver: PurchaseOrderReceiver;
};

export type ReceivedPurchaseOrderEventLogConnection = {
  __typename?: 'ReceivedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<ReceivedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ReceivedPurchaseOrderEventLogEdge = {
  __typename?: 'ReceivedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the ReceivedPurchaseOrderEventLog */
  node: ReceivedPurchaseOrderEventLog;
};

export type ReceivedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<ReceivedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ReceivedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type ReceivedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: ReceivedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ReceivedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type RemoveAuthorizedSubmitterInput = {
  purchaseAccountId: Scalars['String'];
  userId: Scalars['String'];
};

export type RemoveAuthorizedSubmitterResult = MutationResult & {
  __typename?: 'RemoveAuthorizedSubmitterResult';
  authorizedSubmitter?: Maybe<AuthorizedSubmitterV2>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ReopenedPurchaseOrderEventLog = PurchaseOrderEventLog & {
  __typename?: 'ReopenedPurchaseOrderEventLog';
  createdBy: ProcurementsUser;
  createdById: Scalars['ID'];
  dateCreated: Scalars['DateTime'];
  eventType: PurchaseOrderEventLogTypes;
  id: Scalars['ID'];
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID'];
};

export type ReopenedPurchaseOrderEventLogConnection = {
  __typename?: 'ReopenedPurchaseOrderEventLogConnection';
  /** Array of edges. */
  edges: Array<ReopenedPurchaseOrderEventLogEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ReopenedPurchaseOrderEventLogEdge = {
  __typename?: 'ReopenedPurchaseOrderEventLogEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the ReopenedPurchaseOrderEventLog */
  node: ReopenedPurchaseOrderEventLog;
};

export type ReopenedPurchaseOrderEventLogFilter = {
  and?: InputMaybe<Array<ReopenedPurchaseOrderEventLogFilter>>;
  dateCreated?: InputMaybe<DateFieldComparison>;
  eventType?: InputMaybe<PurchaseOrderEventLogTypesFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ReopenedPurchaseOrderEventLogFilter>>;
  purchaseOrderId?: InputMaybe<IdFilterComparison>;
};

export type ReopenedPurchaseOrderEventLogSort = {
  direction: SortDirection;
  field: ReopenedPurchaseOrderEventLogSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ReopenedPurchaseOrderEventLogSortFields {
  DateCreated = 'dateCreated',
  EventType = 'eventType',
  Id = 'id',
  PurchaseOrderId = 'purchaseOrderId'
}

export type ReopenPurchaseOrderInput = {
  purchaseOrderId: Scalars['ID'];
};

export type ReopenPurchaseOrderResult = MutationResult & {
  __typename?: 'ReopenPurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export enum ReservationTargetType {
  Invoice = 'INVOICE',
  Order = 'ORDER',
  WorkOrder = 'WORK_ORDER'
}

export type SendApprovePurchaseOrderEmailInput = {
  purchaseOrderId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};

export type SendApprovePurchaseOrderEmailResult = MutationResult & {
  __typename?: 'SendApprovePurchaseOrderEmailResult';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  successfulUsersEmailed?: Maybe<Array<ProcurementsUser>>;
  unsuccessfulUsersEmailed?: Maybe<Array<UnsuccessfulEmailedUser>>;
};

export type ServiceItem = Item & Node & {
  __typename?: 'ServiceItem';
  buyable: Scalars['Boolean'];
  companyId: Scalars['ID'];
  createdById: Scalars['ID'];
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  duplicateOfId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemType: ItemType;
  modifiedById: Scalars['ID'];
  name: Scalars['String'];
  preferredVendorId?: Maybe<Scalars['ID']>;
  sellable: Scalars['Boolean'];
  standardPrice?: Maybe<Money>;
};

export type ServiceItemConnection = {
  __typename?: 'ServiceItemConnection';
  /** Array of edges. */
  edges: Array<ServiceItemEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ServiceItemEdge = {
  __typename?: 'ServiceItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the ServiceItem */
  node: ServiceItem;
};

export type ServiceItemFilter = {
  and?: InputMaybe<Array<ServiceItemFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ServiceItemFilter>>;
};

export type ServiceItemSnapshot = ItemSnapshot & {
  __typename?: 'ServiceItemSnapshot';
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  itemType: SnapshotItemType;
  name: Scalars['String'];
};

export type ServiceItemSort = {
  direction: SortDirection;
  field: ServiceItemSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ServiceItemSortFields {
  Name = 'name'
}

export type SetIsCostCaptureLocationInput = {
  branchId: Scalars['Int'];
  isCostCaptureLocation: Scalars['Boolean'];
};

export type SetStandardPriceForItemInput = {
  itemId: Scalars['ID'];
  price: MoneyInput;
};

export type SetStandardPriceForItemResult = MutationResult & {
  __typename?: 'SetStandardPriceForItemResult';
  item?: Maybe<Item>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum SnapshotItemType {
  Inventory = 'INVENTORY',
  NonInventory = 'NON_INVENTORY',
  Service = 'SERVICE'
}

/** Sort Directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export type StoreInventoryItem = Node & {
  __typename?: 'StoreInventoryItem';
  availableQuantity: Scalars['Int'];
  dateLastActive: Scalars['ArrowDateTime'];
  id: Scalars['ID'];
  item: InventoryItem;
  itemId: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  reservedQuantity: Scalars['Int'];
  store: InventoryStore;
  storeId: Scalars['ID'];
};


export type StoreInventoryItemReservedQuantityArgs = {
  targetId: Scalars['Int'];
  targetType: ReservationTargetType;
};

export type StoreInventoryItemConnection = {
  __typename?: 'StoreInventoryItemConnection';
  edges: Array<StoreInventoryItemEdge>;
  pageInfo: PageInfo;
};

export type StoreInventoryItemEdge = {
  __typename?: 'StoreInventoryItemEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: StoreInventoryItem;
};

export type StringBoxValue = {
  __typename?: 'StringBoxValue';
  value: Scalars['String'];
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  iLike?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  is?: InputMaybe<Scalars['Boolean']>;
  isNot?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  notILike?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  notLike?: InputMaybe<Scalars['String']>;
};

export type UnarchivePurchaseOrderInput = {
  purchaseOrderId: Scalars['ID'];
};

export type UnarchivePurchaseOrderResult = MutationResult & {
  __typename?: 'UnarchivePurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type UnsuccessfulEmailedUser = {
  __typename?: 'UnsuccessfulEmailedUser';
  companyId: Scalars['ID'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  resultMessage: Scalars['String'];
};

export type UpdatedBranchResult = MutationResult & {
  __typename?: 'UpdatedBranchResult';
  branch?: Maybe<Branch>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateNonInventoryItemInput = {
  allocationType?: InputMaybe<NonInventoryItemAllocation>;
  buyable?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isAllocationRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  preferredVendorId?: InputMaybe<Scalars['String']>;
  sellable?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNonInventoryItemResult = MutationResult & {
  __typename?: 'UpdateNonInventoryItemResult';
  item?: Maybe<NonInventoryItem>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdatePurchaseInput = {
  accountType?: InputMaybe<PurchaseAccountType>;
  departmentId?: InputMaybe<Scalars['ID']>;
  expenseLineId?: InputMaybe<Scalars['ID']>;
  grandTotal?: InputMaybe<MoneyInput>;
  imageUrls?: InputMaybe<Array<Scalars['String']>>;
  /** V2 Field: For new expenses app. */
  isDisputed?: InputMaybe<Scalars['Boolean']>;
  /** V2 Field: For new Expenses app. */
  isPersonalExpense?: InputMaybe<Scalars['Boolean']>;
  /** V2 Field: For new expenses app. */
  isReturn?: InputMaybe<Scalars['Boolean']>;
  lineItems?: InputMaybe<UpdatePurchaseLineItemActions>;
  marketId?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  /** V2 Field: For new Expenses app. */
  purchaseAccountId?: InputMaybe<Scalars['ID']>;
  purchasedAt?: InputMaybe<Scalars['DateTime']>;
  purchaseId: Scalars['Int'];
  purchaseUserId?: InputMaybe<Scalars['Int']>;
  subDepartmentId?: InputMaybe<Scalars['ID']>;
  unofficialVendorName?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};

export type UpdatePurchaseLineItemActions = {
  create?: InputMaybe<Array<AssignItemsToPurchaseInputItem>>;
  delete?: InputMaybe<Array<DeletePurchaseLineItemInput>>;
  update?: InputMaybe<Array<UpdatePurchaseLineItemsInputItem>>;
};

export type UpdatePurchaseLineItemsInputItem = {
  allocationId?: InputMaybe<Scalars['Int']>;
  allocationType?: InputMaybe<PurchaseOrderLineItemAllocation>;
  description?: Scalars['String'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  pricePerUnit: MoneyInput;
  quantity: Scalars['Int'];
};

export type UpdatePurchaseOrderInput = {
  deliverToId?: InputMaybe<Scalars['ID']>;
  lineItems?: InputMaybe<UpdatePurchaseOrderLineItemActions>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  purchaseOrderId: Scalars['ID'];
  reference?: InputMaybe<Scalars['String']>;
  requestingBranchId?: InputMaybe<Scalars['ID']>;
  storeId?: InputMaybe<Scalars['ID']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type UpdatePurchaseOrderLineItemActions = {
  create?: InputMaybe<Array<AssignItemsToUnopenedPurchaseOrderInputItem>>;
  delete?: InputMaybe<Array<DeletePurchaseOrderLineItemInput>>;
  update?: InputMaybe<Array<UpdatePurchaseOrderLineItemsInputItem>>;
};

export type UpdatePurchaseOrderLineItemsInputItem = {
  allocationId?: InputMaybe<Scalars['Int']>;
  allocationType?: InputMaybe<PurchaseOrderLineItemAllocation>;
  description?: Scalars['String'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
  pricePerUnit: MoneyInput;
  quantity: Scalars['Int'];
};

export type UpdatePurchaseOrderResult = MutationResult & {
  __typename?: 'UpdatePurchaseOrderResult';
  message: Scalars['String'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  success: Scalars['Boolean'];
};

export type UpdatePurchaseResult = MutationResult & {
  __typename?: 'UpdatePurchaseResult';
  message: Scalars['String'];
  purchase?: Maybe<Purchase>;
  success: Scalars['Boolean'];
};

export type UserAuthorization = {
  __typename?: 'UserAuthorization';
  objectIds: Array<Scalars['TypePreservingID']>;
  permission: InventoryPermissionV1;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  /** Fetch total count of records */
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  node: ProcurementsUser;
};

export type UserHasAccessToFeatureResult = {
  __typename?: 'UserHasAccessToFeatureResult';
  invoiceReservations: Scalars['Boolean'];
  vendorCreation: Scalars['Boolean'];
};

export type UserOffsetPagingInput = {
  /** How many items to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** The index of the item to start after. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type Vendor = Node & {
  __typename?: 'Vendor';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type VendorConnection = {
  __typename?: 'VendorConnection';
  edges: Array<Maybe<VendorEdge>>;
};

export type VendorEdge = {
  __typename?: 'VendorEdge';
  node: Vendor;
};

export type VendorOffsetPagingInput = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type VendorSnapshot = {
  __typename?: 'VendorSnapshot';
  dateCreated: Scalars['DateTime'];
  id: Scalars['ID'];
  vendorId: Scalars['ID'];
  vendorLocationCity: Scalars['String'];
  vendorLocationLine1: Scalars['String'];
  vendorLocationLine2?: Maybe<Scalars['String']>;
  vendorLocationStateAbbreviation: Scalars['String'];
  vendorLocationStateName: Scalars['String'];
  vendorLocationZipCode: Scalars['String'];
  vendorName: Scalars['String'];
};

export type PurchaseOrderDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PurchaseOrderDetailsQuery = { __typename?: 'Query', purchaseOrder?: { __typename?: 'PurchaseOrder', id: string, lineItems: Array<{ __typename?: 'PurchaseOrderLineItem', itemId: string }> } | null };

export type PurchaseOrdersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type PurchaseOrdersQuery = { __typename?: 'Query', purchaseOrders: { __typename?: 'PurchaseOrderConnection', edges: Array<{ __typename?: 'PurchaseOrderEdge', node: { __typename?: 'PurchaseOrder', id: string, purchaseOrderNumber?: string | null, dateCreated: any, status: PurchaseOrderStatus, vendor: { __typename?: 'Vendor', id: string, name: string }, totalRequestedCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } }> } };

export type CcPurchaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CcPurchaseQuery = { __typename?: 'Query', purchase?: { __typename?: 'Purchase', id: number, inventoryReceivedStatus?: InventoryReceivedStatus | null, unofficialVendorName?: string | null, vendor?: { __typename?: 'Vendor', name: string } | null } | null };

export type VendorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type VendorsQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorConnection', edges: Array<{ __typename?: 'VendorEdge', node: { __typename?: 'Vendor', id: string, name: string } } | null> } };


export const PurchaseOrderDetailsDocument = gql`
    query PurchaseOrderDetails($id: ID!) {
  purchaseOrder(id: $id) {
    id
    lineItems {
      itemId
    }
  }
}
    `;

/**
 * __usePurchaseOrderDetailsQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePurchaseOrderDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PurchaseOrderDetailsQuery, PurchaseOrderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrderDetailsQuery, PurchaseOrderDetailsQueryVariables>(PurchaseOrderDetailsDocument, options);
      }
export function usePurchaseOrderDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrderDetailsQuery, PurchaseOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrderDetailsQuery, PurchaseOrderDetailsQueryVariables>(PurchaseOrderDetailsDocument, options);
        }
export type PurchaseOrderDetailsQueryHookResult = ReturnType<typeof usePurchaseOrderDetailsQuery>;
export type PurchaseOrderDetailsLazyQueryHookResult = ReturnType<typeof usePurchaseOrderDetailsLazyQuery>;
export type PurchaseOrderDetailsQueryResult = ApolloReactCommon.QueryResult<PurchaseOrderDetailsQuery, PurchaseOrderDetailsQueryVariables>;
export const PurchaseOrdersDocument = gql`
    query PurchaseOrders($search: String) {
  purchaseOrders(search: $search) {
    edges {
      node {
        id
        purchaseOrderNumber
        vendor {
          id
          name
        }
        totalRequestedCost {
          amount
          currencyCode
        }
        dateCreated
        status
      }
    }
  }
}
    `;

/**
 * __usePurchaseOrdersQuery__
 *
 * To run a query within a React component, call `usePurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrdersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePurchaseOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>(PurchaseOrdersDocument, options);
      }
export function usePurchaseOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>(PurchaseOrdersDocument, options);
        }
export type PurchaseOrdersQueryHookResult = ReturnType<typeof usePurchaseOrdersQuery>;
export type PurchaseOrdersLazyQueryHookResult = ReturnType<typeof usePurchaseOrdersLazyQuery>;
export type PurchaseOrdersQueryResult = ApolloReactCommon.QueryResult<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>;
export const CcPurchaseDocument = gql`
    query CcPurchase($id: ID!) {
  purchase(id: $id) {
    id
    inventoryReceivedStatus
    unofficialVendorName
    vendor {
      name
    }
  }
}
    `;

/**
 * __useCcPurchaseQuery__
 *
 * To run a query within a React component, call `useCcPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCcPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCcPurchaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCcPurchaseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CcPurchaseQuery, CcPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CcPurchaseQuery, CcPurchaseQueryVariables>(CcPurchaseDocument, options);
      }
export function useCcPurchaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CcPurchaseQuery, CcPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CcPurchaseQuery, CcPurchaseQueryVariables>(CcPurchaseDocument, options);
        }
export type CcPurchaseQueryHookResult = ReturnType<typeof useCcPurchaseQuery>;
export type CcPurchaseLazyQueryHookResult = ReturnType<typeof useCcPurchaseLazyQuery>;
export type CcPurchaseQueryResult = ApolloReactCommon.QueryResult<CcPurchaseQuery, CcPurchaseQueryVariables>;
export const VendorsDocument = gql`
    query Vendors($search: String) {
  vendors(search: $search) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useVendorsQuery__
 *
 * To run a query within a React component, call `useVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useVendorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
      }
export function useVendorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
        }
export type VendorsQueryHookResult = ReturnType<typeof useVendorsQuery>;
export type VendorsLazyQueryHookResult = ReturnType<typeof useVendorsLazyQuery>;
export type VendorsQueryResult = ApolloReactCommon.QueryResult<VendorsQuery, VendorsQueryVariables>;